export default {

    computed: {

      userRole() {

        if(this.$store.getters.getUserRole && this.$store.getters.getUserRole.name != null) {

          if(this.$store.getters.getUserRole.name == 'Administrator' || this.$store.getters.getUserRole.name == 'Administrator JTM' || this.$store.getters.getUserRole.name == 'AdministratorOnline') {
              return "Administrator";
          } else {
              return this.$store.getters.getUserRole.name;
          }

        } else {

          return "";

        }

      },

      catalogId() {
        return this.$store.getters.getCatalogId;
      },

      equipmentCatalogId() {
        return this.$store.getters.getEquipmentCatalogId;
      },

      activeUser() {
        return this.$store.getters.getUser;
      },

      isExternal() {
        return this.$store.getters.isExternal;
      }

    },

    filters: {

      // format a given dateTime into a more readable format
      formatDate(dateTime, separateTime) {

        if(dateTime == null) {
            dateTime = new Date();
        }
        var timeStamp = new Date(dateTime);


        // adjusting timezone (+2)
        // timeStamp.setHours(timeStamp.getHours()+2)

        // var locale = "en-us";
        var locale = 'de-DE';

        var now = new Date();
        var secondsPast = (now.getTime() - timeStamp.getTime() ) / 1000;

        // SECONDS only
        if(secondsPast < 60) {
            if(secondsPast == 1) {
                return 'vor ' + parseInt(secondsPast) + ' Sekunde';
            }
            return 'vor ' + parseInt(secondsPast) + ' Sekunden';
        }
        // MINUTES only
        if(secondsPast < 3600) {
            if(secondsPast <= 60) {
                return 'vor ' + parseInt(secondsPast/60) + ' Minute';
            }
            return 'vor ' + parseInt(secondsPast/60) + ' Minuten';
        }

        // HOURS only
        if(secondsPast <= 86400) {
            if(secondsPast <= 3600) {
                return 'vor ' + parseInt(secondsPast/3600) + ' Stunde';
            }
            else if(secondsPast > 3600 && secondsPast < 7200 ) {
                return 'vor über ' + parseInt(secondsPast/3600) + ' Stunde';
            }
            return 'vor ' + parseInt(secondsPast/3600) + ' Stunden';
        }

        // ELSE
        if(secondsPast > 86400) {

            var hours = addZero(timeStamp.getHours());
            var minutes = addZero(timeStamp.getMinutes());

            // just yesterday
            if(secondsPast > 86400 && secondsPast <= 172800) {
                return 'gestern um ' + hours + ':' + minutes;
            }

            var day = timeStamp.getDate();

            // show month in long version (localized)
            var month = timeStamp.toLocaleString(locale, { month: "long" });

            // only show year if not current year
            var year = timeStamp.getFullYear() == now.getFullYear() ? "" :  " " + timeStamp.getFullYear();

            if(separateTime == true) {
                return day + "." + month + year + '<br />um ' + hours + ':' + minutes + ' Uhr';
            } else {
                return day + "." + month + year + ' um ' + hours + ':' + minutes;
            }

        }

        function addZero(i) {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        }

      }

    },

    methods: {

      can(permission) {

          // console.log("PERMISSION: ", permission);
          // console.log("this.activeUser.permissions: ", this.activeUser.permissions);

          let all = permission.split('.')[0] + '.ALL';
          return this.activeUser.permissions.hasOwnProperty(all) || this.activeUser.permissions.hasOwnProperty(permission);

      },

      validateEmail(email) {
          let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regex.test(email);
      },

      validatePassword(str) {
          let regex = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g;
          return regex.test(str);
      },

      isASCII(str) {
          return /^[\x00-\x7F]*$/.test(str);
      },

      stripHTML(html) {

         var tmp = document.createElement("DIV");

         tmp.innerHTML = html;

         return tmp.textContent || tmp.innerText || "";

      },


      sort(a, b, ascending) {

  			if (typeof a === 'string') {
  				a = a.toLowerCase();
  				a = a.replace("ä", "ae");
  				a = a.replace("ö", "oe");
  				a = a.replace("ü", "ue");
  			}

  			if (typeof b === 'string') {
  				 b = b.toLowerCase();
  				 b = b.replace("ä", "ae");
  				 b = b.replace("ö", "oe");
  				 b = b.replace("ü", "ue");
  			}

  			if(ascending) {
  				return a <= b ? 1 : -1;
  			}

  			return a >= b ? 1 : -1;

  		},

      entityDelete(key, ids, confirm, isSilent=false) {

          var self = this,
          ids = Array.isArray(ids) ? ids : [ids];

          return new Promise(function(resolve, reject) {

              var deleteFunc = function() {

                  var url = self.$config.api + key,
                  axiosRequests = [];

                  ids.forEach(function(id) {
                      axiosRequests.push(self.axios.delete(url + '/' + id));
                  });

                  self.axios.all(axiosRequests)
                      .then(function(res) {

                          self.isSaving = false;
                          if(isSilent == false) {
                              self.$notify.success({
                                  content: self.$t('MSG-SUCCESS-DATA_DELETE')
                              });
                          }

                          resolve(res);

                      })
                      .catch(function(err) {

                          self.isSaving = false;

                          self.$notify.open({
                              content:  self.$t('MSG-ERROR-DATA_DELETE') + ': ' + err.message,
                              type: 'danger'
                          });

                          reject(err);

                      });

              };

              if (confirm != false) {

                  self.$modal.confirm({
                      title: self.$t(confirm + '-TITLE'),
                      content: self.$t(confirm),
                      onOk: function() {
                          deleteFunc();
                      },
                      okText: self.$t(confirm + '-OK'),
                      cancelText: self.$t(confirm + '-CANCEL')
                  });

              } else {

                  deleteFunc();

              }

          });

      },

      entityCreateOrUpdate(key, obj, options={}) {

          options = {
              isSilent: options.isSilent ? options.isSilent : false,
              msg: options.msg ? options.msg : this.$t('MSG-SUCCESS-DATA_SAVE'),
              getParams: options.getParams ? '?'+options.getParams : ''
          };

          var self = this;

          return new Promise(function(resolve, reject) {

              let url = self.$config.api + key + (obj.id ? '/' + obj.id : '') + options.getParams;
              let method = Array.isArray(obj) || obj.id ? 'put' : 'post';

              self.isSaving = true;

              self.axios[method](url, obj)
                  .then(function(res) {

                      self.isSaving = false;

                      if(!options.isSilent) {
                          self.$notify.success({
                              content: self.$t(options.msg)
                          });
                      }

                      resolve(res.data);

                  })
                  .catch(function(err) {

                      self.isSaving = false;

                      self.$notify.open({
                          content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + err.message,
                          type: 'danger'
                      });

                      reject(err);

                  });

          });

      },

      entitiesGet(requests) {

        var self = this;

        self.isLoading = true;

        return new Promise(function(resolve, reject) {

          var axiosRequests = [];

          // convert each request to an axios request
          requests.forEach(function(request) {
              axiosRequests.push(self.axios.get(self.$config.api + request.key, { params: request.params }));
          });

          // let axios collect all responses
          self.axios.all(axiosRequests)

              // once finished axios provides us with a list of result containers
              .then(self.axios.spread(function() {
                  var responses = [].slice.call(arguments),
                  results = {};

                  // extract the data out of each result containers
                  responses.forEach(function(response, index) {

                      // on single requests the response.data contains the object otherwise we need
                      // to get the array from the apiKey field
                      results[requests[index].key] = response.data[requests[index].key] || response.data;

                  });

                  resolve(results);

                  self.isLoading = false;

              }))
              .catch(function(err) {
                  console.log(err);
                  reject(err);
                  self.isLoading = false;
              });

        });

      },

      entityGetList(key, params, targetField) {
          return this.entityGet(key, null, params, targetField);
      },

      entityGet(key, id, params, targetField) {

          var self = this;

          return new Promise(function(resolve, reject) {

              var url = self.$config.api + key;
              if (id) {
                  url += '/' + id;
              }
              self.isLoading = true;
              self.axios.get(url, {
                  params: params
              })
              .then(function(res) {

                  var result = res.data[key] || res.data;

                  if (targetField && self[targetField]) {
                      self[targetField] = result;
                  }

                  self.isLoading = false;

                  resolve(result);

              })
              .catch(function(err) {
                  self.isLoading = false;
                  console.log(err);
                  reject(err);
              });

          });

      },

      taxonomiesGet(list) {

          var self = this;

          return this.entityGet('taxonomy', null, { 'filters[name]': list.join(','), 'include': 'taxonomy.taxonomyTerms' })
              .then(function(res) {
                  self.taxonomies = self.createTaxonomiesHashTable(res);
              });

      },

      // convert a list of taxonomies into a hash table with the
      // taxonomy name as key and a hash map of the terms as value
      createTaxonomiesHashTable(taxonomies) {

          var hashTable = {};

          taxonomies.forEach(function(taxonomy) {
              var termsHashTable = {};
              taxonomy.taxonomyTerms.forEach(function(term) {
                  termsHashTable[term.name] = term;
              });
              hashTable[taxonomy.name] = termsHashTable;
          });

          return hashTable;

      },

      nl2br(text) {

          if(typeof text == 'undefined' || text == "" || text == null) {
              return text;
          }

          return text.replace(/(?:\r\n|\r|\n)/g, '<br />');

      },

      formatPoint2Comma(val, decimals=false) {

		if(val == null || val == "" || typeof val === "undefined") {
			return 0;
		}

          // console.log("val: ", val);

          let number = decimals != false ? (val*1).toFixed(decimals) : val;
		return number.toString().replace(".", ",");

      },

      fileExists(urlToFile) {

	    var xhr = new XMLHttpRequest();

          xhr.open('HEAD', urlToFile, false);
	    xhr.send();

          // console.log("XHR: ", xhr);

		return xhr.status == "404" ? false : true;

	},

      // format a given dateTime into a more readable format
      formatDate(dateTime, separateTime) {

          if(dateTime == null) {
              dateTime = new Date();
          }
          var timeStamp = new Date(dateTime);

          // adjusting timezone (+2)
          // timeStamp.setHours(timeStamp.getHours()+2)

          // var locale = "en-us";
          var locale = 'de-DE';

          var now = new Date();
          var secondsPast = (now.getTime() - timeStamp.getTime() ) / 1000;

          // SECONDS only
          if(secondsPast < 60) {
              if(secondsPast == 1) {
                  return 'vor ' + parseInt(secondsPast) + ' Sekunde';
              }
              return 'vor ' + parseInt(secondsPast) + ' Sekunden';
          }
          // MINUTES only
          if(secondsPast < 3600) {
              if(secondsPast <= 60) {
                  return 'vor ' + parseInt(secondsPast/60) + ' Minute';
              }
              return 'vor ' + parseInt(secondsPast/60) + ' Minuten';
          }

          // HOURS only
          if(secondsPast <= 86400) {
              if(secondsPast <= 3600) {
                  return 'vor ' + parseInt(secondsPast/3600) + ' Stunde';
              }
              else if(secondsPast > 3600 && secondsPast < 7200 ) {
                  return 'vor über ' + parseInt(secondsPast/3600) + ' Stunde';
              }
              return 'vor ' + parseInt(secondsPast/3600) + ' Stunden';
          }

          // ELSE
          if(secondsPast > 86400) {

              var hours = this.addZero(timeStamp.getHours());
              var minutes = this.addZero(timeStamp.getMinutes());

              // just yesterday
              if(secondsPast > 86400 && secondsPast <= 172800) {
                  return 'gestern um ' + hours + ':' + minutes;
              }

              var day = timeStamp.getDate();
              // show month in long version (localized)
              var month = timeStamp.toLocaleString(locale, { month: "long" });
              // only show year if not current year
              var year = timeStamp.getFullYear() == now.getFullYear() ? "" :  " " + timeStamp.getFullYear();

              // return day + "." + month + year + ' um ' + hours + ':' + minutes;
              if(separateTime == true) {
                  return day + "." + month + year + '<br /><span class="is-size-7">' + hours + ':' + minutes + ' Uhr</span>';
              } else {
                  return day + "." + month + year + ' um ' + hours + ':' + minutes;
              }


          }

      },

      formatDate2(ISOdate, showTime=true) {

		let date = new Date(ISOdate);
		let month = this.addZero(date.getMonth()+1);
		let dt = this.addZero(date.getDate());

		let returnDate = dt + '.' + month + '.' + date.getFullYear();

		if(showTime) {
			let minutes = this.addZero(date.getMinutes());
			returnDate += ' | ' + this.addZero(date.getHours()) + ':' + minutes;
		}

		return returnDate;

	},

      addZero(i) {

          if (i < 10) {
              i = "0" + i;
          }

          return i;

      },

  }
}
